// eslint-disable-next-line import/no-unresolved
import { apiUrl } from '../../../utils/api';
import { apiBasePath } from '../../BasicUrl';


const SallerData = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getSallerApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.seller}`,
                method: "POST",
                body: data,

            }),
        }),
        getUpdateSallerApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.sellerUpdate}`,
                method: "POST",
                body: data,
            })
        }),
        getUpdateSallerAccountApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.sellerUpdate}`,
                method: "POST",
                body: data,
            })
        }),
        // updatePhoto: build.mutation({
        //     query: (data) => ({
        //         url: `${apiUrl.sallerPhoto}`,
        //         method: "POST",
        //         body: data,
        //     })
        // }),
        // updateTime: build.mutation({
        //     query: (data) => ({
        //         url: `${apiUrl.storeTime}`,
        //         method: "POST",
        //         body: data,
        //     })
        // }),

        activateApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.sellerActivate}`,
                method: "POST",
                body: data
            }),
        }),

        approvelApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.sellerApprove}`,
                method: "POST",
                body: data
            }),
        }),


    }),
    overrideExisting: false,
});
// export const { useGetSallersApiQuery, useUpdateSallerMutation, useUpdatePhotoMutation, useUpdateLogoMutation, useUpdateTimeMutation, useGetCityQuery, useActivateDeactivateUserApiMutation, useApprovelDeactivateUserApiMutation } = extendedApi;
export const { useGetSallerApiMutation, useActivateApiMutation, useGetUpdateSallerApiMutation, useGetUpdateSallerAccountApiMutation, useApprovelApiMutation } = SallerData;
